import { Button, Checkbox, FormField, MaskedInput, UIText1, UIText2 } from '@cian/ui-kit';
import * as style from './ModalForm.css';
import { PRIVACY_LINK, PROCESSING_LINK } from 'shared/constants/privacyPolicyLink';
import { TModalForm } from 'shared/types/form';
import clsx from 'clsx';

type TModalFormProps = TModalForm;

export const ModalForm: React.FC<TModalFormProps> = ({
  onSendForm,
  onClose,
  onFilledInput,
  phoneRef,
  checkBoxRef,
  disabledButton,
  device,
  user,
}) => {
  const { phone } = user;

  return (
    <form
      onSubmit={e => e.preventDefault()}
      className={clsx(style['container'], device !== 'desktop' && style['container-tablet'])}
    >
      <div className={style['description']}>
        <UIText1>
          Сервис доступен для сдачи квартиры в долгосрочную аренду в Москве и Московской области, Санкт-Петербурге и
          Ленинградской области, Воронеже, Ростове-на-Дону, Краснодаре
        </UIText1>
      </div>
      <div className={style['form']}>
        <div className={style['input']}>
          <FormField withoutMargin label="Телефон">
            <MaskedInput
              onChange={() => onFilledInput()}
              mask="+7 000 000 00-00"
              size="M"
              placeholderChar="+"
              defaultValue={phone}
              placeholder="+7 999 999 99-99"
              inputRef={phoneRef}
              lazy
            />
          </FormField>
        </div>
      </div>
      <div className={style['notice']}>
        <div className={style['notice-checkbox']}>
          <div data-name="checkbox">
            <Checkbox inputRef={checkBoxRef} onChange={() => onFilledInput()} />
          </div>
        </div>
        <div className={style['notice-text']}>
          <UIText2>
            Нажимая кнопку, я даю{' '}
            <a href={PROCESSING_LINK} className={style['link']} target="_blank" rel="noreferrer">
              согласие на обработку персональных данных
            </a>
            . Ознакомиться с{' '}
            <a href={PRIVACY_LINK} className={style['link']} target="_blank" rel="noreferrer">
              Политикой конфиденциальности.
            </a>
          </UIText2>
        </div>
      </div>
      <div className={style['buttons-container']}>
        <Button theme="fill_white_primary" size="M" onClick={onClose}>
          Отменить
        </Button>
        <Button onClick={onSendForm} disabled={disabledButton} size="M">
          Отправить
        </Button>
      </div>
    </form>
  );
};
